var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"flex flex-col px-4 w-full xl:w-2/3 xl:mx-auto"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }